/*
 * hellopanda-scrollto
 */
const HELLOPANDA_SCROLLTOGGLE = {
  lastScrollY: 0,
  ticking: false,
  scrollRecords: [],
  containers: document.querySelectorAll('.wp-block-hellopanda-scrolltoggle-block'),
  adminStaticWidth: 600, // 상단 메뉴가 고정이 되는 순간
  adminHeader: document.querySelector('#wpadminbar'),
  init: function() {
    const _ = this;
    document.addEventListener('DOMContentLoaded', function () {
      _.lastScrollY = window.scrollY;
      window.addEventListener('scroll', () => _.onScroll());
      _.onScroll();
    });
  },

  onScroll: function () {
    const _ = this;
    if (!_.ticking) {
      window.requestAnimationFrame(function () {
        _.detect_scroll_toggle();
        _.ticking = false;
      });
      _.ticking = true;
    }
  },

  detect_scroll_toggle: function () {

    const _ = this;
    let currentScroll = window.scrollY;

    // 📌 iOS 등의 bounce scroll 방지
    // 0보다 작거나, 문서 전체 높이를 초과하는 값은 무시하거나 보정
    const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    if (currentScroll < 0) currentScroll = 0;
    if (currentScroll > maxScroll) currentScroll = maxScroll;

    const direction = currentScroll > _.lastScrollY ? 'down' : 'up';
    const isAdminFixed = _.adminHeader ? ['fixed'].includes(window.getComputedStyle(_.adminHeader).position) : false;

    // 컨테이너 배열
    _.containers.forEach((container, index) => {
      const trigger = container.dataset.trigger;
      const start = container.dataset.start || '';
      const sense = parseInt(container.dataset.sense || '0', 10);
      const topdelay = parseInt(container.dataset.topdelay || '0', 10);
      const containerDisplay = window.getComputedStyle(container).display;

      if (currentScroll < topdelay) {
        container.classList.add('is-scroll-top');
        container.style.marginTop = '';
      } else {
        container.classList.remove('is-scroll-top');
      }

      // 관리자 + 모바일 + 600px
      // 상단 설정을 하지 않은 컨테이너 대상
      if (_.adminHeader && containerDisplay != 'none') {
        if (!isAdminFixed && !container.style.top && !container.style.bottom) {
          if (_.adminHeader.offsetHeight >= currentScroll) {
            container.style.marginTop = currentScroll * -1 + 'px';
          } else {
            container.style.marginTop = _.adminHeader.offsetHeight * -1 + 'px';
          }
        }
      }

      if (this.scrollRecords[index] === undefined) {
        this.scrollRecords[index] = {
          active: start === 'start-show' ? true : false,
          direction: '',
          scroll: currentScroll,
          scrolled: false
        }
      }

      if (trigger === 'scroll-down' && direction === 'down') {

        if (this.scrollRecords[index].scroll + sense < currentScroll || !this.scrollRecords[index].scrolled) {
          container.classList.add('is-scroll');
          this.scrollRecords[index] = {
            active: true,
            direction: 'down',
            scroll: currentScroll
          }
        } else if (this.scrollRecords[index].active && this.scrollRecords[index].direction === 'down') {
          this.scrollRecords[index].scroll = currentScroll;
        }

      } else if (trigger === 'scroll-up' && direction === 'up') {

        if (this.scrollRecords[index].scroll - sense > currentScroll || !this.scrollRecords[index].scrolled) {
          container.classList.add('is-scroll');
          this.scrollRecords[index] = {
            active: true,
            direction: 'up',
            scroll: currentScroll
          }
        } else if (this.scrollRecords[index].active && this.scrollRecords[index].direction === 'up') {
          this.scrollRecords[index].scroll = currentScroll;
        }

      } else {

        if (trigger === 'scroll-up' && this.scrollRecords[index].scroll + sense < currentScroll) {
          container.classList.remove('is-scroll');
          this.scrollRecords[index].active = false;
          this.scrollRecords[index].scroll = currentScroll;
        } else if (trigger === 'scroll-down' && this.scrollRecords[index].scroll - sense > currentScroll) {
          container.classList.remove('is-scroll');
          this.scrollRecords[index].active = false;
          this.scrollRecords[index].scroll = currentScroll;
        }

        if (this.scrollRecords[index].active && this.scrollRecords[index].scrolled) {
          this.scrollRecords[index].active = false;
        }

      }

      container.classList.add('is-scrolled');
      this.scrollRecords[index].scrolled = true;
    });
    _.lastScrollY = currentScroll;
  },
};
HELLOPANDA_SCROLLTOGGLE.init();